<div class="content" *ngIf="isMspLoaded">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> Billing Detail
      </h1>
    </div>
    <div class="index-content device-detail">
      <div class="header-title">
        <h5>Billing Info</h5>
      </div>
      <div class="content-info evnets border-t-radius-none" style="margin: 0px;">
        <div class="content-body">
          <div class="row license-detail billing">
            <div class="col-md-4">
              <ul class="info-list">
                <li><div class="title">Company</div></li>
                <li><div class="value">{{docDetailInfo.Company}}</div></li>
              </ul>
            </div>
            <div class="col-md-4">
              <ul class="info-list">
                <li><div class="title">PPC PRO Account</div></li>
                <li><div class="value">{{docDetailInfo.RegionName}}</div></li>
              </ul>
            </div>
            <div class="col-md-4">
              <ul class="info-list">
                <li>
                  <div class="title" *ngIf="docDetailInfo.PaymentType === PaymentTypeIndex.Prepaid">Statement Date</div>
                  <div class="title" *ngIf="docDetailInfo.PaymentType === PaymentTypeIndex.Monthly">Statement Period</div>
                </li>
                <li><div class="value">{{this.docDetailInfo.Period}}</div></li>
              </ul>
            </div>
            <div class="col-md-4">
              <ul class="info-list">
                <li><div class="title">P.O. Number</div></li>
                <li><div class="value">{{docDetailInfo.DocNo}}</div></li>
              </ul>
            </div>
            <div class="col-md-4">
              <ul class="info-list">
                <li><div class="title">Email</div></li>
                <li><div class="value">{{docDetailInfo.CompanyEmail}}</div></li>
              </ul>
            </div>
            <div class="col-md-4">
              <ul class="info-list">
                <li><div class="title">Invoice Number</div></li>
                <li><div class="value">{{docDetailInfo.CorrNo}}</div></li>
              </ul>
            </div>
            <!-- <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title" *ngIf="docDetailInfo.DocType === 1 else docDate">Invoice Date</div>
                  <ng-template #docDate>
                    <div class="title">Date</div>
                  </ng-template>
                </li>
                <li><div class="value">{{docDetailInfo.DocDate}}</div></li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <section style="margin: 30px 0 0 0;" *ngIf="show_Doc_Info.Summary">
      <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
        <div class="page-title sub-title">
          <h5 class="float-left">Summary</h5>
        </div>
      </div>
    </section>
    <section style="margin: 0 0 0 0;" *ngIf="show_Doc_Info.Summary">
      <div class="content-info licenseUsedDetail border-t-radius-none">
        <p-treeTable [value]="summaryList" [columns]="summaryTable_cols">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr>
              <td class="name">
                <div class="inline-flex">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <div class="rowDataName">PPCRPOMONTHLY</div>
                </div>
              </td>
              <td><span *ngIf="rowData.isDefaultQuantity" class="important">*</span> {{rowData.total_quantity}}</td>
              <td>${{rowData.unitprice}}</td>
              <td>${{rowData.total_amount | number: '1.2-2'}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td>PPCPROMONTHLY TOTAL</td>
              <td></td>
              <td></td>
              <td>${{summaryTotal.amount | number: '1.2-2'}}</td>
            </tr>
          </ng-template>
        </p-treeTable>
        <p class="note" *ngIf="this.docDetailInfo.MinCharge > 0 && docDetailInfo.PaymentType === PaymentTypeIndex.Monthly"><span>*</span> A minimum quantity of {{this.docDetailInfo.MinCharge}} devices is required when using PPC PRO. </p>
      </div>
    </section>
    <section style="margin: 30px 0 0 0;" *ngIf="show_Doc_Info.Detail">
      <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
        <div class="page-title sub-title">
          <h5 class="float-left">Detail</h5>
        </div>
      </div>
    </section>
    <section style="margin: 0 0 0 0;" *ngIf="show_Doc_Info.Detail">
      <div class="content-info licenseUsedDetail border-t-radius-none">
        <p-treeTable [value]="deviceUsageList" [columns]="deviceUsageTable_cols">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr>
              <td class="name">
                <div class="inline-flex">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <div class="rowDataName" style="-webkit-box-orient: vertical;">{{rowData.name}}</div>
                </div>
              </td>
              <td>{{rowData.last_quantity}}</td>
              <td>{{rowData.quantity - rowData.last_quantity}}</td>
              <td>{{rowData.quantity}}</td>
              <!-- <td>{{rowData.unitprice}}</td>
              <td>{{rowData.amount}}</td> -->
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </section>
  </div>
</div>
